/**
 * Firm capabilities (firm-model spec §4.2, R2). Code checks capabilities, never role
 * names; the role → capability table lives on the server (server/src/firm/capabilities.ts)
 * and `/v1/me` reports the caller's list, which the panel uses to show or hide controls.
 */
export type Capability =
  | "manage_billing"
  | "manage_members"
  | "edit_standards"
  | "edit_library"
  | "view_activity"
  | "use_product";

export const CAPABILITIES: readonly Capability[] = [
  "manage_billing",
  "manage_members",
  "edit_standards",
  "edit_library",
  "view_activity",
  "use_product",
];
